module.exports = __webpack_public_path__ + "static/media/comment.e62d9265.svg";